export default "__VITE_ASSET__40312868__"